import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const refreshToHomeGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);

    if (router.navigated) {
        return true;
    }

    const url = state.url;
    const [urlWithoutQuery, queryString] = url.split('?');

    if (urlWithoutQuery === '/home' || urlWithoutQuery.endsWith('/home')) {
        return true;
    }

    if (urlWithoutQuery.includes('/request/')) {
        const segments = urlWithoutQuery.split('/');
        const requestIndex = segments.indexOf('request');
        const guid = segments[requestIndex + 1];

        if (guid) {
            return router.createUrlTree(['/request', guid, 'home']);
        }
    }

    if (queryString && urlWithoutQuery.includes('/new-request')) {
        const queryParams: Record<string, string> = {};
        queryString.split('&').forEach(param => {
            const [key, value] = param.split('=');
            if (key && value) {
                queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
            }
        });
        return router.createUrlTree(['/new-request/home'], { queryParams });
    }

    return router.createUrlTree(['/home']);
};
